import { Box, BoxProps } from "@mui/material";
import React from "react";

export const PageContent = (props: BoxProps) => (
    <Box
        display="flex"
        flexDirection="column"
        flexGrow={2}
        sx={{ marginLeft: "192px", overflowX: "hidden" }}
    >
        {props.children}
    </Box>
);
